// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"yN","category":"yO","tab":"yP","selected":"yQ","isRental":"yR"};